import React from 'react';
import { ClockCircleOutlined } from '@ant-design/icons';

const DashboardHeader = () => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
      <div className="space-y-1">
        <h1 className="text-2xl md:text-3xl font-heading text-neutral-800">
          Tableau de bord
        </h1>
        <p className="text-sm text-neutral-500">
          Vue d'ensemble de votre plateforme événementielle
        </p>
      </div>
      <div className="flex items-center space-x-4 text-sm text-neutral-500">
        <ClockCircleOutlined className="text-primary-500" />
        <span>Dernière mise à jour: Il y a 5 min</span>
      </div>
    </div>
  );
};

export default DashboardHeader; 